const MIME_TYPE = 'application/x-lastminuproject-drag+json'

export function emptyDropReceiver() {
  return { enabled: false, connections: [] }
}

function list(value) {
  if (Array.isArray(value)) return value.map(item => String(item).trim()).filter(Boolean)
  if (value === null || value === undefined || value === '') return []
  return String(value).split(',').map(item => item.trim()).filter(Boolean)
}

export function normalizeEnvelope(value) {
  if (!value) return null
  let envelope = value
  if (typeof value === 'string') {
    try { envelope = JSON.parse(value) } catch (error) { return null }
  }
  if (!envelope || typeof envelope !== 'object' || Number(envelope.version) !== 1) return null
  if (!envelope.channel || !envelope.entityType || envelope.entityId === undefined || envelope.entityId === null) return null
  return { ...envelope, payload: envelope.payload && typeof envelope.payload === 'object' ? envelope.payload : {} }
}

export function envelopeFromDataTransfer(dataTransfer) {
  if (!dataTransfer) return null
  let raw = ''
  try { raw = dataTransfer.getData(MIME_TYPE) || dataTransfer.getData('text/plain') } catch (error) { return null }
  return normalizeEnvelope(raw)
}

export function hasEngineDragType(dataTransfer) {
  if (!dataTransfer || !dataTransfer.types) return false
  return Array.from(dataTransfer.types).includes(MIME_TYPE)
}

export function matchingConnection(receiver, envelope) {
  if (!receiver || receiver.enabled !== true || !envelope) return null
  return (Array.isArray(receiver.connections) ? receiver.connections : []).find(connection => {
    if (!connection || connection.enabled === false) return false
    if (connection.channel && String(connection.channel) !== String(envelope.channel)) return false
    const entityTypes = list(connection.entityTypes)
    if (entityTypes.length && !entityTypes.includes(String(envelope.entityType))) return false
    const sourceModules = list(connection.sourceModules)
    if (sourceModules.length && !sourceModules.includes(String(envelope.sourceModuleId))) return false
    return true
  }) || null
}

function mappings(value) {
  if (Array.isArray(value)) return value
  if (value && typeof value === 'object') return Object.keys(value).map(field => ({ field, value: value[field] }))
  if (!value || typeof value !== 'string') return []
  try { return mappings(JSON.parse(value)) } catch (error) { return [] }
}

function readPath(source, path) {
  return path.split('.').reduce((value, key) => (value !== null && value !== undefined ? value[key] : undefined), source)
}

function resolveValue(value, envelope, dropContext) {
  if (typeof value !== 'string') return value
  return value.replace(/\[\[(drag|drop)\|\|([^\]]+)\]\]/g, (match, family, rawPath) => {
    const path = rawPath.trim()
    const source = family === 'drop' ? dropContext : envelope
    let resolved = readPath(source, path)
    if (resolved === undefined && family === 'drag') resolved = readPath(envelope.payload || {}, path.replace(/^payload\./, ''))
    return resolved === undefined || resolved === null ? '' : resolved
  })
}

function typedValue(type, value) {
  switch (type) {
    case 'number':
      return value === '' || value === null || value === undefined ? null : Number(value)
    case 'bool':
      return value === true || (value !== false && value !== 'false' && value !== 0 && value !== '0' && value !== '')
    case 'text':
    default:
      return value === null || value === undefined ? '' : String(value)
  }
}

export function mappedDropFields(connection, envelope, dropContext = {}) {
  return mappings(connection && connection.mappings).reduce((result, mapping) => {
    const field = mapping && (mapping.field || mapping.key || mapping.target)
    if (!field) return result
    const value = mapping.value !== undefined ? mapping.value : mapping.source
    const resolved = resolveValue(value, envelope, dropContext)
    result[field] = typedValue(mapping.type || mapping.typedata || 'text', resolved)
    return result
  }, {})
}

export { MIME_TYPE }
